import { useAsync } from '@tiger/hooks';
import ErrorBox from 'components/ErrorBox';
import Loading from 'components/Loading';
import DocumentItem from '../components/DocumentItem';
import Empty from '../components/Empty';
import store from '../request';

const Tax: React.FC = () => {
    const [{ loading, data, error }, getData] = useAsync(() => store.getTaxDocumentList());

    const render = () => {
        if (loading) {
            return <Loading className="mt-5" />;
        }

        if (error) {
            return <ErrorBox error={error} onClick={getData} />;
        }

        return (
            <div className="mt-4">
                {data?.length > 0 ? (
                    data?.map((val, index) => <DocumentItem id={val.id} description={val.description} key={index} />)
                ) : (
                    <Empty />
                )}
            </div>
        );
    };

    return (
        <div className="report-tax-root pt-2">
            <div className="text-muted">
                {__('Your tax documents will become available in February of the following year.')}
            </div>
            {render()}
        </div>
    );
};

export default Tax;
